import type { FC, ReactNode } from "react";
import { Box, Row, TextWithTooltip } from "@hightouch/htui";

export type PanelHeaderProps = {
  title: string;
  /** Trailing controls: `size="xs"` icon buttons, which fit the header's height. */
  actions?: ReactNode;
};

/** Compact title bar for docked side panels (the ad editor's layers and comments rails), shared so side-by-side panels line up. */
export const PanelHeader: FC<PanelHeaderProps> = ({ title, actions }) => (
  <Row
    align="center"
    justify="space-between"
    gap={2}
    px={3}
    py={2}
    flexShrink={0}
    borderBottomWidth="hairline"
    borderBottomStyle="solid"
    borderColor="base.divider"
  >
    <Box minW={0}>
      <TextWithTooltip size="sm" fontWeight="medium" color="text.secondary">
        {title}
      </TextWithTooltip>
    </Box>
    {actions && (
      <Row align="center" gap={1} flexShrink={0}>
        {actions}
      </Row>
    )}
  </Row>
);
